import { useEffect, useState } from 'react';

// Anti-flash de skeleton (plano UX 04): só mostra o estado de loading se a
// carga passar de `delayMs` (default 300ms). Cargas rápidas não piscam
// skeleton; cargas lentas ganham skeleton estável (sem CLS).
// Uso: const showSkeleton = useDelayedLoading(isLoading);
export function useDelayedLoading(isLoading, delayMs = 300) {
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!isLoading) {
            setShow(false);
            return undefined;
        }
        const timer = setTimeout(() => setShow(true), delayMs);
        return () => clearTimeout(timer);
    }, [isLoading, delayMs]);

    return show;
}
